import axios from 'axios';
const API_ADDRESS = process.env.REACT_APP_API_URL || 'http://51.15.11.170:4200/api';

const LOG_ADDRESS = process.env.REACT_APP_LOG_URL || 'https://log.maytapi.com';

export function get(path, params) {
	const url = `${API_ADDRESS}${path}`;

	return axios({
		method: 'get',
		url,
		params,
		withCredentials: true,
	}).then((resp) => resp.data);
}

export function post(path, data, params) {
	const url = `${API_ADDRESS}${path}`;
	return axios({
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url,
		data: '__json__=' + encodeURIComponent(JSON.stringify(data)),
		params,
		withCredentials: true,
	});
}
export function livePost(path, data, params) {
	const url = `${path}`;
	return axios({
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url,
		data: '__json__=' + encodeURIComponent(JSON.stringify(data)),
		params,
		withCredentials: true,
	});
}
export function log(path, data, params) {
	const url = `${LOG_ADDRESS}${path}`;
	return axios({
		method: 'post',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		url,
		data: '__json__=' + encodeURIComponent(JSON.stringify(data)),
		params,
	});
}

const WAPI_URL = 'https://api.maytapi.com';
// const WAPI_URL = 'http://localhost:5000';

export function toWapi(path, token, data) {
	const url = `${WAPI_URL}${path}`;

	if (path && path.includes('//listPhones')) return { success: false, data: null };
	return axios({
		method: data ? 'post' : 'get',
		headers: {
			'x-maytapi-key': token,
		},
		url,
		data,
	});
}
